module.exports = __webpack_public_path__ + "media/images/pavilion-balcony-8e4b7e59.jpg";